// main tools
import { useState, useEffect, useCallback } from 'react'

// context
import { NetworkContext } from './context'

// types
import { NetworkContextDataType } from './context'
import { FC, ReactNode } from 'react'

type NetworkProviderProps = {
  children: ReactNode
}

export const NetworkProvider: FC<NetworkProviderProps> = ({ children }) => {
  const [network, setNetwork] = useState<NetworkContextDataType>({
    info: undefined,
    since: undefined
  })

  const context = { ...network }

  const getNetworkConnection = useCallback(() => {
    const connection = navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection || {
        rtt: 0,
        downlink: 0,
        online: false,
        saveData: false,
        effectiveType: 'Offline'
      }

    return {
      rtt: connection.rtt,
      online: navigator.onLine,
      downlink: connection.downlink,
      saveData: connection.saveData,
      effectiveType: connection.effectiveType
    }
  }, [])

  const updateNetworkConnection = useCallback(() => {
    setNetwork({
      since: new Date(),
      info: getNetworkConnection()
    })
  }, [getNetworkConnection])

  useEffect(() => {
    const handleNetworkChange = () => {
      setInterval(() => {
        updateNetworkConnection()
      }, 5000)
    }

    window.addEventListener('online', handleNetworkChange)
    window.addEventListener('offline', handleNetworkChange)

    updateNetworkConnection()
    handleNetworkChange()

    return () => {
      window.removeEventListener('online', handleNetworkChange)
      window.removeEventListener('offline', handleNetworkChange)
    }
  }, [updateNetworkConnection])

  return (
    <NetworkContext.Provider value={context}>
      {children}
    </NetworkContext.Provider>
  )
}
